module.exports = "static/assets/d1f14e4e1372d8f9c0908d2f45aa5b54.svg";